import { connect } from 'react-redux'
import Header from './header'

const mapState = (state, ownProps) => {
  return {
    ...ownProps,
  }
}

const mapDispatch = dispatch => {
  return {}
}

export default connect(mapState, mapDispatch)(Header)



// WEBPACK FOOTER //
// ./src/components/common/header/header.connect.js